import ContentGrid_List from './ContentGrid_List';

export default ContentGrid_List;
